var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTacha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.31 127.1",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.47 0C29-.56-.8 29.33 0 63.5c1 41.86 34.39 65 64.09 63.54 34.94 0 62.07-27.44 63.17-61.87C128.22 35.74 106.07.71 63.47 0zm32.87 81.87a4 4 0 010 5.71L87 97a4.06 4.06 0 01-5.72 0L63 78.7 44.75 97A4 4 0 0139 97l-9.37-9.37a4 4 0 010-5.71l18.29-18.31-18.25-18.25a4 4 0 010-5.71L39 30.28a4 4 0 015.71 0L63 48.53l18.25-18.25a4.06 4.06 0 015.72 0l9.37 9.37a4 4 0 010 5.71L78.09 63.61z",
    fill: "#878789",
    "data-name": "Capa 3"
  }))));
}

export default SvgTacha;